import { useReferralsContext } from '@user/components/Referrals/context'
import {
  clearCustomerActionCreator,
  setCustomerActionCreator,
  setDiscountActionCreator,
} from '@user/components/Referrals/state'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import { referralDataMapperModelToDTO } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralDrawer/hooks/utils'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'
import { useMemo } from 'react'

export function useHandlers({ formVariant }: ReferralFormProps) {
  const [state, dispatch] = useReferralsContext()
  const context = useFormikContext<ILeadFormModel>()

  const isInline = useMemo<boolean>(() => {
    return formVariant === ReferralFormVariant.Inline
  }, [formVariant])

  const isInValid = useMemo<boolean>(() => {
    return Boolean(
      isInline && context?.errors?.referral && context?.touched?.referral,
    )
  }, [context?.errors?.referral, context?.touched?.referral, isInline])

  function onClearClick() {
    dispatch(clearCustomerActionCreator())
    if (formVariant === ReferralFormVariant.Inline) {
      const model = referralDataMapperModelToDTO({
        ...state,
        referralCustomerId: '',
        referralLocationCode: '',
      })
      context?.setFieldValue?.('referral', model)
    }
  }

  function onCustomerChange(locationId: string, locationCode?: string) {
    dispatch(
      setCustomerActionCreator({
        referralCustomerId: locationId,
        referralLocationCode: locationCode || '',
      }),
    )
    if (formVariant === ReferralFormVariant.Inline) {
      const model = referralDataMapperModelToDTO({
        ...state,
        referralCustomerId: locationId,
        referralLocationCode: locationCode || '',
      })
      context?.setFieldValue?.('referral', model)
    }
  }

  function onDiscountChange(
    referralDiscountId: string,
    referralDiscountCode: string,
  ) {
    dispatch(
      setDiscountActionCreator({ referralDiscountCode, referralDiscountId }),
    )
    if (formVariant === ReferralFormVariant.Inline) {
      const model = referralDataMapperModelToDTO({
        ...state,
        referralDiscountCode,
        referralDiscountId,
      })
      context?.setFieldValue?.('referral', model)
    }
  }

  return {
    onClearClick,
    onCustomerChange,
    onDiscountChange,
    isInValid,
    error: isInValid ? context?.errors?.referral : undefined,
  } as const
}
